<template>
  <div class="menuBody" style="padding-left: 25px">
    <AccountingDialog
      :param="diaLogData"
      ref="AccountingDialog"
      @Visible="Visible"
    />
    <div class="menuTool" style="width: 100%">
      <el-card class="box-card">
        <el-row :gutter="10">
          <div
            style="
              border-bottom: 1px solid rgba(234, 237, 241, 1);
              width: 100%;
              height: 30px;
              margin-bottom: 10px;
            "
          >
            财务科目列表
            <div style="float: right; margin-top: -5px">
              <el-button
                type="primary"
                size="small"
                plain
                style="background: #38a38a; color: #fff; border-radius: 9px"
                v-Jurisdiction="'expense:web:fm:accountSet:save'"
                @click="DownCourseAdd()"
                >新增下级科目</el-button
              >
            </div>
          </div>
          <div style="width: 150px; float: left">
            <el-input
              placeholder="请输入科目名称"
              size="small"
              v-model="CourseName"
            ></el-input>
          </div>
          <div style="width: 150px; float: left; margin-left: 70px">
            <el-input
              placeholder="请输入科目代号"
              size="small"
              v-model="CourseCode"
            ></el-input>
          </div>
          <div style="width: 150px; float: left; margin-left: 70px">
            <el-input
              placeholder="请输入上级科目代号"
              size="small"
              v-model="UpCourseCode"
            ></el-input>
          </div>
          <div style="width: 170px; float: left; margin-left: 70px">
            <el-select
              clearable
              v-model="value"
              placeholder="请选择支出项"
              @change="expend()"
              size="small"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
          <div style="float: left; margin-left: 70px">
            <el-button
              type="primary"
              size="small"
              plain
              style="background: #246ce5; color: #fff; border-radius: 9px"
              v-Jurisdiction="'expense:web:fm:accountSet:selectListPage'"
              @click="Inquire()"
              >查询</el-button
            >
          </div>
          <div style="float: right">
            <el-button
              type="primary"
              size="small"
              plain
              style="background: #246ce5; color: #fff; border-radius: 9px"
              v-Jurisdiction="'expense:web:fm:accountSet:save'"
              @click="PropertyAdd()"
              >财务科目</el-button
            >
          </div>
          <el-table
            tooltip-effect="light"
            :data="tableData"
            v-loading="loading"
            @selection-change="handleSelectionChange"
            style="overflow-y: scroll; float: right; margin-top: 30px"
            row-key="id"
            :default-expand-all="false"
            :header-cell-style="{
              background: '#eef1f6',
              color: '#606266',
              'font-weight': '600',
              height: '45px',
              'text-align': 'left',
            }"
            :cell-style="{ 'text-align': 'left' }"
            :stripe="true"
            :tree-props="{ children: 'children' }"
          >
            <el-table-column type="selection" width="55px"></el-table-column>
            <el-table-column
              show-overflow-tooltip
              prop="subjectsCode"
              label="科目代号"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              prop="subjectsName"
              label="科目名称"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              prop="parentCode"
              label="上级代号"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              prop="updateTima"
              label="修改时间"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              prop="expendItem"
              label="支出项目"
            >
              <template slot-scope="scope">
                <el-tag
                  :type="scope.row.expendItem === '1' ? 'success' : 'warning'"
                  disable-transitions
                  >{{ scope.row.expendItem === "1" ? "是" : "否" }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="subjectAttributes" label="科目属性">
              <template slot-scope="scope">
                <el-tag type="success" v-if="scope.row.subjectAttributes == '0'"
                  >预算</el-tag
                >
                <el-tag v-if="scope.row.subjectAttributes == '1'"
                  >非预算</el-tag
                >
                <el-tag type="warning" v-if="scope.row.subjectAttributes == '2'"
                  >其他</el-tag
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="subjectRemarks"
              label="备注信息"
            ></el-table-column>
            <el-table-column fixed="right" label="操作">
              <template slot-scope="scope">
                <el-button
                  @click="editMenu(scope.row)"
                  type="primary"
                  icon="el-icon-edit"
                  circle
                  size="small"
                  v-Jurisdiction="'expense:web:fm:accountSet:save'"
                  title="修改"
                ></el-button>
                <el-button
                  @click="delMenu(scope.row)"
                  type="danger"
                  icon="el-icon-delete"
                  circle
                  size="small"
                  v-Jurisdiction="'expense:web:fm:accountSet:delete'"
                  title="删除"
                  v-debounce
                ></el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 30, 40]"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            style="float: right; margin-top: 25px"
          >
          </el-pagination>
        </el-row>
      </el-card>
    </div>
  </div>
</template>
<script>
import AccountingDialog from "../common/AccountingDialog";
export default {
  name: "AccountingManagement",
  components: { AccountingDialog },
  data() {
    return {
      loading: true,
      total: 0, //默认数据总数
      pagesize: 10, //每页的数据条数
      currentPage: 1, //默认开始页面
      CourseCode: "",
      CourseName: "",
      UpCourseCode: "",
      tableData: [],
      options: [
        {
          value: "1",
          label: "是",
        },
        {
          value: "0",
          label: "否",
        },
      ],
      value: "",
      diaLogVisible: false,
      diaLogData: {
        diaLogVisible: false,
        diaLogType: "",
        paramObj: {},
        paramList: [],
      },
      AllData: "",
      USERObj: [],
      ProjectMana: "",
    };
  },
  methods: {
    expend() {},
    handleSelectionChange(val) {
      this.USERObj = val;
    },
    getMsgFormSon(data) {
      this.AllData = data;
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.getAllMenu();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getAllMenu();
    },
    Inquire() {
      // 查询
      let PageSize = {
        page: this.currentPage, // 当前页
        size: this.pagesize, // 每页大小
        subjectsCode: this.CourseCode, // 财务科目代号
        subjectsName: this.CourseName, // 科目名称
        parentCode: this.UpCourseCode, // 上级科目代号
        expendItem: this.value, // 支出项目
      };
      this.$http
        .post(this.$requestUrl.POST_CHARGE_LIST, PageSize)
        .then((res) => {
          let data = res.data;
          if (200 === data.code) {
            this.total = data.data.total;
            let arr = [];
            for (let val of data.data.records) {
              val.updateTima = val.updateTime.slice(0, 10);
              arr.push(val);
            }
            this.tableData = arr;
            this.CourseCode = "";
            this.CourseName = "";
            this.UpCourseCode = "";
            this.value = "";
          } else {
            this.$message.error(result.msg);
          }
        })
        .catch(() => {
          this.$message.error(this.$errorMessage.SEVER_ERROR);
        });
    },
    getAllMenu() {
      let PageSize = {
        page: this.currentPage, // 当前页
        size: this.pagesize, // 每页大小
      };
      this.$http
        .post(this.$requestUrl.POST_CHARGE_LIST, PageSize)
        .then((res) => {
          let data = res.data;
          if (200 === data.code) {
            let arr = [];
            for (let val of data.data.records) {
              if (val.updateTime != null) {
                val.updateTima = val.updateTime.substring(0, 10);
              }
              arr.push(val);
            }
            this.total = data.data.total;
            this.loading = false;
            this.tableData = data.data.records;
          } else {
            this.$message.error(result.msg);
            this.loading = false;
          }
        })
        .catch(() => {
          this.$message.error(this.$errorMessage.SEVER_ERROR);
        });
    },
    PropertyAdd() {
      // 添加项目
      if (this.USERObj.length == 0) {
        this.$refs.AccountingDialog.title = "添加";
        this.$refs.AccountingDialog.dialogVisible = true;
        this.$refs.AccountingDialog.UserDisplay = 0;
        this.$refs.AccountingDialog.type = "财务";
        let obj = {
          code: "科目代号",
          name: "科目名称",
          item: "支出项目",
          attribute: "科目属性",
          remark: "备注信息",
        };
        let row = {};
        row.obj = obj;
        this.$refs.AccountingDialog.formLabelAlign = row;
      }
    },
    editMenu(row) {
      // 修改
      this.$refs.AccountingDialog.title = "修改";
      this.$refs.AccountingDialog.dialogVisible = true;
      this.$refs.AccountingDialog.UserDisplay = 0;
      this.$refs.AccountingDialog.disburseval = row.subjectAttributes;
      this.$refs.AccountingDialog.valueone = row.expendItem;
      this.$refs.AccountingDialog.type = "财务";
      let obj = {
        code: "科目代号",
        name: "科目名称",
        item: "支出项目",
        attribute: "科目属性",
        remark: "备注信息",
      };
      row.obj = obj;
      this.$refs.AccountingDialog.formLabelAlign = row;
    },
    DownCourseAdd() {
      if (this.USERObj.length > 1) {
        this.$message({
          type: "warning",
          message: "请选择一条科目信息",
        });
      } else if (this.USERObj.length < 1) {
        this.$message({
          type: "warning",
          message: "请选择一条科目信息",
        });
      } else {
        // 添加下级科目
        this.$refs.AccountingDialog.title = "添加下级科目";
        this.$refs.AccountingDialog.dialogVisible = true;
        this.$refs.AccountingDialog.UserDisplay = 1;
        this.$refs.AccountingDialog.type = "财务";
        let obj = {
          code: "科目代号",
          name: "科目名称",
          item: "支出项目",
          superior: "上级科目代号",
          attribute: "科目属性",
          remark: "备注信息",
        };
        let row = {
          parentCode: this.USERObj[0].subjectsCode,
        };
        row.obj = obj;
        this.$refs.AccountingDialog.formLabelAlign = row;
      }
    },
    delMenu(row) {
      this.$confirm("是否确认要删除该科目?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http
            .post(this.$requestUrl.DELETE_CHARGE + "?id=" + row.id)
            .then((res) => {
              let result = res.data;
              if (200 === result.code) {
                this.getAllMenu();
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
              } else {
                this.$message({
                  type: "warning",
                  message: "删除失败",
                });
              }
            })
            .catch(() => {
              this.$message.error(this.$errorMessage.SEVER_ERROR);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    Visible(data) {
      if (data == false) {
        this.getAllMenu();
      }
    },
  },
  mounted() {
    this.getAllMenu();
    // this.getUserOffice();
  },
};
</script>

<style lang="scss">
.menuBody {
  width: 100%;
  .menuTool {
    .el-card {
      .el-card__body {
        padding: 10px 20px;
      }
    }

    margin-bottom: 10px;
  }

  .el-table {
    td {
      padding: 5px;
    }

    th {
      padding: 5px;
    }

    .success-row {
      background: #f0f9eb;
    }
  }
}
</style>
<style>
</style>